// extracted by mini-css-extract-plugin
module.exports = {"pageJump":"PageJump_pageJump__MTqqK","pageJumpInput":"PageJump_pageJumpInput__2KH0W"};